import React from 'react';
import { Box } from '@mui/material';

interface WmsPrimaryActionBarProps {
  primaryAction: React.ReactNode;
  secondaryAction?: React.ReactNode;
}

const WmsPrimaryActionBar: React.FC<WmsPrimaryActionBarProps> = ({
  primaryAction,
  secondaryAction,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 1.5,
      borderTop: '1px solid',
      borderColor: 'divider',
      pt: 2,
      mt: 1,
    }}
  >
    <Box sx={{ order: { xs: 2, sm: 1 } }}>{secondaryAction}</Box>
    <Box sx={{ ml: { sm: 'auto' }, order: { xs: 1, sm: 2 } }}>{primaryAction}</Box>
  </Box>
);

export default WmsPrimaryActionBar;
